module.exports = __webpack_public_path__ + "static/img/1.4072152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/1.png
// module id = 7sQT
// module chunks = 35